import { format } from 'date-fns';
import { FULFILLMENT } from '../../constants';
import { ACTION_TYPES, FULFILMENT_OPTIONS } from '@detox/actions';
import { isCurrentFulfilmentOption } from '../../components/Fulfilment/helpers';

const REQUEST_STATUS = FULFILLMENT.REQUEST_STATUS;

export const initialState = {
  status: REQUEST_STATUS.IDLE,
  data: [],
  selectedTimeSlot: undefined
};

const formatDeliveryTimeSlots = (slots = []) => {
  return slots.reduce((acc, cur) => {
    const slotDate = format(new Date(cur.slotStartDate), 'MM/dd/yyyy');

    if (slotDate in acc) {
      acc = { ...acc, [slotDate]: [...acc[slotDate], cur.timeDescription] };
    } else {
      acc = { ...acc, [slotDate]: [cur.timeDescription] };
    }

    return acc;
  }, {});
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.FULFILMENT.ESHOP_TIME_SLOT_LOADING:
    case 'GET_LOGISTIC_APPOINTMENTS_SLOTS_LOADING': {
      if (
        !isCurrentFulfilmentOption(action.meta, [
          FULFILMENT_OPTIONS.HOME_DELIVERY
        ])
      ) {
        return state;
      }
      return {
        ...state,
        status: REQUEST_STATUS.PENDING
      };
    }

    case ACTION_TYPES.FULFILMENT.ESHOP_TIME_SLOT_SUCCESS: {
      if (
        !isCurrentFulfilmentOption(action.meta, [
          FULFILMENT_OPTIONS.HOME_DELIVERY
        ])
      ) {
        return state;
      }
      return {
        ...state,
        status: REQUEST_STATUS.SUCCEEDED,
        data: formatDeliveryTimeSlots(action.payload?.slots)
      };
    }

    case 'GET_LOGISTIC_APPOINTMENTS_SLOTS_SUCCESS': {
      const deliveryTimeslot = formatDeliveryTimeSlots(action.payload.slots);

      return {
        ...state,
        status: REQUEST_STATUS.SUCCEEDED,
        data: deliveryTimeslot
      };
    }
    case 'SELECT_APPOINTMENTS_TIME_SLOT': {
      return {
        ...state,
        selectedTimeSlot: action.payload
      };
    }
    case 'SET_DELIVERY_MODE':
    case 'RESET_SELECTED_LOGISTIC_TIME_SLOT': {
      return {
        ...state,
        selectedTimeSlot: undefined
      };
    }
    default: {
      return state;
    }
  }
};
